import Card from '@/components/atoms/Card';
import { Text } from '@/components/atoms/Text';
import { cn } from '@/lib/utils';

export const FormCard = ({
  children,
  title,
  className,
  headerRight,
}: {
  children: React.ReactNode;
  title?: string;
  className?: string;
  headerRight?: React.ReactNode;
}) => {
  const hasHeader = !!title || !!headerRight;

  return (
    <Card
      roudnessLevel='s'
      classNames={{
        root: cn(
          'py-4 px-0 dark:border-gray-300 h-fit dark:dark-scrollbar flex flex-col',
          className
        ),
      }}
    >
      {hasHeader && (
        <div className='flex items-center justify-between px-4 gap-2'>
          {title && (
            <Text className='text-left text-body-l-medium dark:text-gray-900 text-gray-950'>
              {title}
            </Text>
          )}
          {headerRight && <div className='flex items-center'>{headerRight}</div>}
        </div>
      )}
      <div
        className={cn(
          'px-4',
          hasHeader ? 'pt-2' : ''
        )}
      >
        {children}
      </div>
    </Card>
  );
};
